module.exports = __webpack_public_path__ + "static/media/person-placeholder.646dfcb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/person-placeholder.jpg
// module id = 167
// module chunks = 0